export default "__VITE_ASSET__CaXkYHff__"